module.exports = __webpack_public_path__ + "assets/5a41a8e1bca8732c79419c1fd91078b6.mp3";